// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1fFtT","messages":"Chat_messages__2SzfQ","dateDivider":"Chat_dateDivider__3H7iN"};